import styled from 'styled-components';
import { GlobalToken } from 'antd';
import { StyledPageProps } from './InstallationValidation.utils';
import { StageCard } from '@/comp/StationStages/styled';

export const StyledInstallationPage = styled.div<StyledPageProps & { theme: { token: GlobalToken } }>`
  height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: ${({ theme: { token } }) => token.colorBgLayout};

  .test-time-banner {
    display: ${({ $testTimeVisible }) => ($testTimeVisible ? 'inline-flex' : 'none')};
    height: 2.375rem;
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.padding}px;
    background: ${({ theme: { token } }) => token.colorBgBase};
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;

    span {
      color: ${({ theme: { token } }) => token.colorPrimary};
      font-family: ${({ theme: { token } }) => token.fontFamily};
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.4;
      text-align: left;
    }
  }

  .installer-main-container {
    flex: 1;
    padding: 0 ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.padding}px;
    width: 100%;
    color: ${({ theme: { token } }) => token.colorText};
    overflow-y: auto;
    height: 100%;
    position: relative;

    @media (max-width: ${({ theme: { token } }) => token.screenMD}px) {
      padding: 0 ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingXL}px
        ${({ theme: { token } }) => token.padding}px;
    }

    &::-webkit-scrollbar {
      display: none;
      width: 0;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .installer-station-select-header {
    display: flex;
    gap: 1rem;

    @media (max-width: 1024px) {
      flex-direction: column-reverse;
      gap: 1.5rem;
      align-items: stretch;

      .installer-station-select {
        width: 100%;
      }
    }

    ${StageCard} {
      flex: 1;
    }

    @media (max-width: ${({ theme: { token } }) => token.screenMD}px) {
      flex-direction: column-reverse;

      ${StageCard} {
        flex: unset;
        width: 34rem;
        margin: 0;
        margin-bottom: 1rem;
      }
    }
  }

  .installer-station-select {
    width: 24.5rem;
    max-width: 100%;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    @media (min-width: ${({ theme: { token } }) => token.screenMD}px) {
      margin-top: ${({ theme: { token } }) => token.marginLG}px;
      align-self: flex-start;
    }
  }

  .installer-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .installer-header-text {
      color: ${({ theme: { token } }) => token.colorText};
      font-family: ${({ theme: { token } }) => token.fontFamily};
      font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    }
  }
`;
